module.exports = __webpack_public_path__ + "img/pmma.1bc1ed28.jpg";